import React from 'react';
import {GoLocation} from 'react-icons/go';
import {BsFillTelephoneFill} from 'react-icons/bs';
import {motion} from 'framer-motion';
const About = () => {
  return <section className='about'>
    <div className="aboutContainer">
      <div className="bowl">
        <motion.img initial={{y:"260%"}} animate={{y:0}} transition={{delay:0.9}} className='circle-3' src="/circle.png" alt="cicrle1" />
        <motion.img initial={{y:"-300%"}} animate={{y:0}} transition={{delay:0.7}} className='circle-2' src="/circle.png" alt="cicrle2" />
        <motion.img initial={{y:"-300%"}} animate={{y:0}} transition={{delay:0.5}} className='circle-1' src="/circle.png" alt="cicrle3" />
        <motion.img className='bowlImg' initial={{y:"-200%"}} animate={{y:0}} transition={{delay:0.3}} src="/bowl.png" alt="bowl" />
      <div>
      </div></div>
      <div className="information">
        <h1>Sweets Wala</h1>
        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Temporibus libero voluptas est repellendus. Minus eos, officia commodi quo adipisci perspiciatis, facilis explicabo impedit aliquam repellat tempore, labore culpa dolorum fuga laborum maiores debitis enim id itaque molestiae voluptate laudantium vitae.</p>
        <div>
        <GoLocation/> <span>45/8 New York</span>
        </div>
        <div>
          <BsFillTelephoneFill/><span>+523698122</span>
        </div>
      </div>
    </div>
  </section>
}

export default About